(() => {
  const DURATION = 300;
  const EASE = 'ease-in-out';

  // Animate open/close for details elements
  function animateDetails(e, summary) {
    e.preventDefault();
    
    const details = summary.parentElement;
    if (!details) return;

    const content = summary.nextElementSibling;
    if (!content) return;

    const isOpen = details.hasAttribute('open');
    const contentHeight = content.scrollHeight;

    content.style.overflow = 'hidden';
    content.style.transition = `height ${DURATION}ms ${EASE}`;

    if (!isOpen) {
      details.setAttribute('open', '');
      content.style.height = '0px';
      content.offsetHeight;
      content.style.height = contentHeight + 'px';
    } else {
      content.style.height = contentHeight + 'px';
      content.offsetHeight;
      content.style.height = '0px';
    }

    content.addEventListener('transitionend', () => {
        if (isOpen) details.removeAttribute('open');
        content.style.height = '';
        content.style.overflow = '';
    }, { once: true });
  }

  // Delegated click handler
  document.addEventListener('click', e => {
    const summary = e.target.closest('summary');
    if (summary) animateDetails(e, summary);
  });
})();
